export class ListInventoryResourceTypesResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "resourceTypes",
            "baseName": "resourceTypes",
            "type": "Array<ResourceType>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListInventoryResourceTypesResponse.attributeTypeMap;
    }
    constructor() {
    }
}
